import Router, { RawLocation, Route } from 'vue-router';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import type { History } from 'vue-router/src/history/base';

type Navigation = typeof Router.prototype.push;

function navigation<Fn extends Navigation>(
  fn: Fn,
  location: Parameters<Fn>[0],
  onResolve: Parameters<Fn>[1],
  onReject: Parameters<Fn>[2]
) {
  if (onResolve || onReject) {
    return fn.call(this, location, onResolve, onReject);
  }

  return (fn as (location: RawLocation) => Promise<Route>).call(this, location).catch((err) => {
    if (Router.isNavigationFailure(err)) {
      // resolve err
      return err;
    }
    // rethrow error
    return Promise.reject(err);
  });
}

const originalPush = Router.prototype.push;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Router.prototype.push = function push(location, onResolve, onReject) {
  return navigation.call(this, originalPush, location, onResolve, onReject);
};

const originalReplace = Router.prototype.replace;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Router.prototype.replace = function replace(location, onResolve, onReject) {
  return navigation.call(this, originalReplace, location, onResolve, onReject);
};

class PatchedRouter extends Router {
  getHistory(): History {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return this.history as History;
  }
}

export default PatchedRouter;
